import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-transaction-layout',
  templateUrl: './transaction-layout.component.html',
  styleUrls: ['./transaction-layout.component.scss'],
})
export class TransactionLayoutComponent implements OnInit {
  id: any;
  transactionData: any;
  reloadPage: string;
  user: {
    user: {
      role: string;
      email: string;
      userId: string;
      mobile: string;
      token: string;
      name: string;
      onSession: string;
      plan: string;
    };
  }
  userName:String;

  totalAmountOfItems = 0;
  userEmail: string;
  userMobile: string;
  constructor(
    private activatedRoute: ActivatedRoute,
    private transactionService: TansactionService,
    private loginSignupService: LoginSignupService,
    private localStorageService: LocalStorageService
  ) {
    this.user = this.loginSignupService.getUserSession();
    const role = this.localStorageService.getItem("role");
    this.userName = this.localStorageService.getItem("name");
    this.userEmail = this.localStorageService.getItem("email");
    this.userMobile = this.localStorageService.getItem("mobile");
    this.activatedRoute.params.subscribe((data) => {
      this.id = data.id;
      var val = {
        orderId: data.id,
      };
      this.transactionService.verifyCart(val).then((data: any) => {
        if (data.data != null) {
          this.transactionData = data.data;
          const amount = this.transactionData.payment ? this.transactionData.payment.amount : this.transactionData.order.amount;
          this.totalAmountOfItems = amount / 100;
          if (!this.transactionData.microProduct) {
            this.localStorageService.setItem('plan', data.data.plan);
            this.localStorageService.setItem('isNCR', false);
          }
        }
      });
    });

    this.reloadPage = this.localStorageService.getItem('reloadPage');
    this.localStorageService.setItem('reloadPage', 'false');
    if (this.reloadPage === 'true') {
      window.location.reload();
    }
  }

  ngOnInit() {}
}
